import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange} from "@angular/core";

@Component({
  selector: "validation-determinant",
  templateUrl: "./validation-determinant.component.html",
  styles: [],
})
export class ValidationDeterminantComponent implements OnInit, OnChanges {
  @Input() public booleanValue = true;
  @Output() public booleanValueResponse = new EventEmitter();
  public trueValueChecked: any = 1;

  public ngOnInit() {
    this.updateBooleanValue();
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.booleanValue && changes.booleanValue.currentValue) {
      this.booleanValue = changes.booleanValue.currentValue;
    }
    this.updateBooleanValue();
  }

  public updateBooleanValue() {
    if (this.booleanValue !== undefined) {
      if (this.booleanValue === true) {
        this.trueValueChecked = 1;
      } else if (this.booleanValue === false) {
        this.trueValueChecked = 0;
      }
    } else {
      this.trueValueChecked = 1;
    }
    this.booleanValueChanged(this.trueValueChecked === 1);
  }

  public booleanValueChanged(newValue: boolean) {
    if (newValue === true) {
      this.trueValueChecked = 1;
    } else {
      this.trueValueChecked = 0;
    }
    this.booleanValueResponse.emit(newValue);
  }
}
